export const access_token = 'u7XAWyOamG8uP6qcW4PtfaXhFJXEXNTX6lqE3NGR'
export const URL = 'https://hwwscimuxe.execute-api.ca-central-1.amazonaws.com/dev'